var poll_default = {
  "fontElementMap": "a0qh2",
  "container": "etmBX",
  "fullscreen": "Iqyls",
  "background_overlay": "chmop",
  "with_image": "iSUOV",
  "options": "YBiEj",
  "webview": "rkSV8",
  "grid": "T0R0E",
  "option": "fOiKb",
  "cta_button": "pE7s6",
  "add_option": "ZxmKn",
  "see_more": "_2iSGE",
  "list": "oUDNU",
  "column": "uOJjN",
  "additional_note": "EIOP4",
  "spinner": "-wdXu",
  "spin": "BnGtK",
  "shown": "_31MDW",
  "error": "dYiCs"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
